'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 24px;\n  height: 24px;\n  fill: ', ' !important;\n  ', ';\n'], ['\n  width: 24px;\n  height: 24px;\n  fill: ', ' !important;\n  ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Styles


var Svg = _styledComponents2.default.svg(_templateObject, function (_ref) {
  var disabled = _ref.disabled,
      on = _ref.on;
  return disabled || !on ? _colors.darkGrey : _colors.white;
}, (0, _polished.transitions)('fill .2s ease-in-out'));

exports.default = Svg;